import { render, staticRenderFns } from "./reservations.vue?vue&type=template&id=d7083194&scoped=true&"
import script from "./reservations.vue?vue&type=script&lang=js&"
export * from "./reservations.vue?vue&type=script&lang=js&"
import style0 from "./reservations.vue?vue&type=style&index=0&id=d7083194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7083194",
  null
  
)

export default component.exports